export const EXSBITEM_DELETE_RESET = 'EXSBITEM_DELETE_RESET'
export const EXSBITEM_DELETE_SET_ERROR = 'EXSBITEM_DELETE_SET_ERROR'
export const EXSBITEM_DELETE_SET_DELETED = 'EXSBITEM_DELETE_SET_DELETED'
export const EXSBITEM_DELETE_TOGGLE_LOADING = 'EXSBITEM_DELETE_TOGGLE_LOADING'
